import React from 'react';
import { TaskCard, Text } from '@medely/ui-kit';
import { TaskCardLayout } from './TaskCard';
import { useProNavigate } from '../../contexts';

export type ProPoolOnboardingProps = {
  poolId: number;
  locationId: number;
  facilityName: string;
  positionIds: number[];
  positionNames: string[];
  onTrackClick?: () => void;
};

export const ProPoolOnboarding = (props: ProPoolOnboardingProps) => {
  const { poolId, locationId, facilityName, positionNames, positionIds, onTrackClick } = props;
  const { navigate } = useProNavigate();

  const goToPoolInvite = () => {
    if (onTrackClick) {
      onTrackClick();
    }

    navigate('LocationOnboarding', { poolId, locationId, positionIds: String(positionIds) });
  };

  const positionsString = positionNames?.length ? positionNames.join(', ') : null;
  const positionsTitle = `Position${positionNames?.length === 1 ? '' : 's'}`;

  const ProPoolInviteBody = () => (
    <>
      <Text size="m">{facilityName}</Text>
      {positionsString && (
        <Text size="m">
          {positionsTitle}: {positionsString}
        </Text>
      )}
    </>
  );

  return (
    <TaskCardLayout>
      <TaskCard
        iconProps={{ name: 'exclamation-triangle', color: 'error' }}
        title={'Complete your pool onboarding'}
        body={<ProPoolInviteBody />}
        onClick={goToPoolInvite}
      />
    </TaskCardLayout>
  );
};
